import { PubMedItem } from '@repo/roche-xx-shared';
import React from 'react';
import { DataSearchView } from '../../search/data-search';
import { PubMedListItem } from '../../search/data-search/list-items/pubmed-list-item';
import { fetchPubMedList, fetchPubMedSearch, fetchPubMedTabs } from '../../search/data-search/queries';
import { SearchTrackingType } from '../../search/tracking';
import { Props } from './types';

// Currently there is no working endpoint for PubMed and therefore we are just rendering
// nothing. Needs to be completely/clean deleted when the decommission is fix:
// https://roche-ds.atlassian.net/browse/EXTCWP-1443
export const PubMed = ({ slot }: Props): JSX.Element => {
  return <></>;
  // <DataSearchView<PubMedItem>
  //   slot={slot}
  //   searchTrackingType={SearchTrackingType.PUB_MED}
  //   alwaysShowTabs={true}
  //   tabName='category'
  //   pageName='page'
  //   queryName='query'
  //   showInput={true}
  //   searchTabs={true}
  //   fetchTabs={fetchPubMedTabs}
  //   fetchList={fetchPubMedList}
  //   fetchSearch={fetchPubMedSearch}
  //   itemRenderer={(item, index, trackingData) => (
  //     <PubMedListItem key={`${item.publishingDate}-${index}`} item={item} trackingData={trackingData} />
  //   )}
  // />
  // );
};
